import { render, staticRenderFns } from "./Bookmark.vue?vue&type=template&id=2a4fdca7&scoped=true&"
import script from "./Bookmark.vue?vue&type=script&lang=ts&"
export * from "./Bookmark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4fdca7",
  null
  
)

export default component.exports